var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Circle Arrow Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,0C10.8,0,0,10.8,0,24s10.8,24,24,24s24-10.8,24-24S37.2,0,24,0 M24,46C11.9,46,2,36.1,2,24S11.9,2,24,2  s22,9.9,22,22S36.1,46,24,46"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "20 13.6 18.5 15.2 26.5 24 18.5 32.8 20 34.3 29.5 24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrow);
export default __webpack_public_path__ + "static/media/circle-arrow.53b58503b60b386dfebbe914aa7b25bd.svg";
export { ForwardRef as ReactComponent };